import React, { useState, useEffect } from "react";
import Logo from "./../Assets/img/AdminLTELogo.png";
import getAxiosInstance from "./../Utils/axios";
import { createGlobalState } from "react-hooks-global-state";

const initialState = { menu: "dashboard" };
const { useGlobalState } = createGlobalState(initialState);

export default function Menu() {
  const [user, setUser] = useState(null);
  const [selectedTab, setSelectedTab] = useGlobalState("menu");

  useEffect(() => {
    getAxiosInstance()
      .get("/admin/me")
      .then((res) => setUser(res.data.result))
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (window.location.pathname.indexOf("/location") >= 0)
      setSelectedTab("location");
    else if (window.location.pathname.indexOf("broadcasting") >= 0)
      setSelectedTab("broadcast");
    else if (window.location.pathname.indexOf("/reports") >= 0)
      setSelectedTab("report");
    else if (window.location.pathname.indexOf("user") >= 0)
      setSelectedTab("user");
  }, []);

  return (
    <>
      <aside className="main-sidebar sidebar-light-primary elevation-4">
        <a href="#" className="brand-link">
          {/* <img src={Logo} alt="AdminLTE Logo" className="brand-image img-circle elevation-3" style={{ opacity: ".8" }} /> */}
          <span className="brand-text font-weight-light ml-2">PW ADMIN</span>
        </a>
        <div className="sidebar">
          <nav style={{ marginTop: 80 }}>
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item active">
                <a
                  href="/"
                  className={`nav-link ${
                    selectedTab === "dashboard" && "active"
                  }`}
                  onClick={() => setSelectedTab("dashboard")}
                >
                  <i className="nav-icon fas fa-th" />
                  <p>Dashboard</p>
                </a>
              </li>

              {user?.permissions.user_management && (
                <li
                  className={`nav-item ${
                    selectedTab == "user" ? "menu-is-opening menu-open" : ""
                  }`}
                >
                  <a
                    href="#"
                    className={`nav-link ${
                      selectedTab == "user" ? "active" : ""
                    }`}
                    onClick={() =>
                      selectedTab == "user"
                        ? setSelectedTab("")
                        : setSelectedTab("user")
                    }
                  >
                    <i className="nav-icon fas fa-users" />
                    <p>
                      Manage Users
                      <i className="fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul
                    className={`nav nav-treeview ${
                      selectedTab == "user" ? "d-block" : "d-none"
                    }`}
                  >
                    <li className="nav-item">
                      <a
                        href="/all-users"
                        className={`nav-link ${
                          window.location.pathname.indexOf("/all-users") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>All Users</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/add-user"
                        className={`nav-link ${
                          window.location.pathname.indexOf("/add-user") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Add Users</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}

              {user?.permissions.meta_data_management && (
                <li
                  className={`nav-item ${
                    selectedTab === "location" && "menu-is-opening menu-open"
                  }`}
                >
                  <a
                    href="#"
                    className={`nav-link ${
                      selectedTab === "location" && "active"
                    }`}
                    onClick={() =>
                      selectedTab == "location"
                        ? setSelectedTab("")
                        : setSelectedTab("location")
                    }
                  >
                    <i className="nav-icon fas fa-location-arrow" />
                    <p>
                      Locations
                      <i className="fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul
                    className={`nav nav-treeview ${
                      selectedTab == "location" ? "d-block" : "d-none"
                    }`}
                  >
                    {(user?.user_type === "admin" ||
                      user?.assign_level < 1) && (
                      <li className="nav-item">
                        <a
                          href="/location/countries"
                          className={`nav-link ${
                            window.location.pathname.indexOf("/countries") >=
                              0 && "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon" />
                          <p>Countries</p>
                        </a>
                      </li>
                    )}
                    {(user?.user_type === "admin" ||
                      user?.assign_level < 2) && (
                      <li className="nav-item">
                        <a
                          href="/location/states"
                          className={`nav-link ${
                            window.location.pathname.indexOf("/states") >= 0 &&
                            "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon" />
                          <p>States</p>
                        </a>
                      </li>
                    )}
                    {(user?.user_type === "admin" ||
                      user?.assign_level < 3) && (
                      <li className="nav-item">
                        <a
                          href="/location/cities"
                          className={`nav-link ${
                            window.location.pathname.indexOf("/cities") >= 0 &&
                            "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon" />
                          <p>Cities</p>
                        </a>
                      </li>
                    )}
                    {(user?.user_type === "admin" ||
                      user?.assign_level < 4) && (
                      <li className="nav-item">
                        <a
                          href="/location/buildings"
                          className={`nav-link ${
                            window.location.pathname.indexOf("/buildings") >=
                              0 && "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon" />
                          <p>Buildings</p>
                        </a>
                      </li>
                    )}
                    {(user?.user_type === "admin" ||
                      user?.assign_level < 5) && (
                      <li className="nav-item">
                        <a
                          href="/location/floors"
                          className={`nav-link ${
                            window.location.pathname.indexOf("/floors") >= 0 &&
                            "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon" />
                          <p>Floors</p>
                        </a>
                      </li>
                    )}
                    <li className="nav-item">
                      <a
                        href="/location/screens"
                        className={`nav-link ${
                          window.location.pathname.indexOf("/screens") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Screens</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}

              {user?.permissions.message_management && (
                <li
                  className={`nav-item ${
                    selectedTab === "broadcast" && "menu-is-opening menu-open"
                  }`}
                >
                  <a
                    href="#"
                    className={`nav-link ${
                      selectedTab === "broadcast" && "active"
                    }`}
                    onClick={() =>
                      selectedTab == "broadcast"
                        ? setSelectedTab("")
                        : setSelectedTab("broadcast")
                    }
                  >
                    <i className="nav-icon fas fa-broadcast-tower" />
                    <p>
                      Broadcasting
                      <i className="fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul
                    className={`nav nav-treeview ${
                      selectedTab == "broadcast" ? "d-block" : "d-none"
                    }`}
                  >
                    <li className="nav-item">
                      <a
                        href="/broadcasting/media"
                        className={`nav-link ${
                          window.location.pathname.indexOf("media") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Media</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/broadcasting/campaigns"
                        className={`nav-link ${
                          window.location.pathname.indexOf("campaigns") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Campaigns</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}

              {user?.permissions.report_management && (
                <li
                  className={`nav-item ${
                    selectedTab === "report" && "menu-is-opening menu-open"
                  }`}
                >
                  <a
                    href="#"
                    className={`nav-link ${
                      selectedTab === "report" && "active"
                    }`}
                    onClick={() =>
                      selectedTab == "report"
                        ? setSelectedTab("")
                        : setSelectedTab("report")
                    }
                  >
                    <i className="nav-icon fas fa-file" />
                    <p>
                      Report Management
                      <i className="fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul
                    className={`nav nav-treeview ${
                      selectedTab == "report" ? "d-block" : "d-none"
                    }`}
                  >
                    {/* <li className="nav-item">
                                            <a href="/reports/user-dashboard" className={`nav-link ${window.location.pathname.indexOf("user-dashboard") >= 0 && "active"}`}>
                                                <i className="far fa-circle nav-icon" />
                                                <p>User Dashboard</p>
                                            </a>
                                        </li> */}
                    <li className="nav-item">
                      <a
                        href="/reports/user-log"
                        className={`nav-link ${
                          window.location.pathname.indexOf("user-log") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>User Log</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/reports/screen-status"
                        className={`nav-link ${
                          window.location.pathname.indexOf("screen-status") >=
                            0 && "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Screen Status</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/reports/message-log"
                        className={`nav-link ${
                          window.location.pathname.indexOf("message-log") >=
                            0 && "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Message Log</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/reports/scheduled-message"
                        className={`nav-link ${
                          window.location.pathname.indexOf(
                            "scheduled-message"
                          ) >= 0 && "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Scheduled Message</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/reports/screen-available"
                        className={`nav-link ${
                          window.location.pathname.indexOf(
                            "screen-available"
                          ) >= 0 && "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Screen Available</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}
              {console.log(user)}
              {user?.permissions.update_management && (
                <li
                  className={`nav-item ${
                    selectedTab == "update" ? "menu-is-opening menu-open" : ""
                  }`}
                >
                  <a
                    href="#"
                    className={`nav-link ${
                      selectedTab == "update" ? "active" : ""
                    }`}
                    onClick={() =>
                      selectedTab == "update"
                        ? setSelectedTab("")
                        : setSelectedTab("update")
                    }
                  >
                    <i className="nav-icon fa fa-plus-square" />
                    <p>
                      Manage Updates
                      <i className="fas fa-angle-left right" />
                    </p>
                  </a>
                  <ul
                    className={`nav nav-treeview ${
                      selectedTab == "update" ? "d-block" : "d-none"
                    }`}
                  >
                    <li className="nav-item">
                      <a
                        href="/updates"
                        className={`nav-link ${
                          window.location.pathname.indexOf("/all-users") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Recent Updates</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/add-updates"
                        className={`nav-link ${
                          window.location.pathname.indexOf("/add-user") >= 0 &&
                          "active"
                        }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>Add New Update</p>
                      </a>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
}
